(function () {
  const HINTS = {
    NM: 'Near Mint (NM) — Karte ist in einwandfreiem bis leicht gespieltem Zustand mit minimalen bis keinen sichtbaren Gebrauchsspuren.',
    EX: 'Excellent (EX) — Leichte Gebrauchsspuren, z. B. feine Kantenabnutzung oder minimale Kratzer.',
    LP: 'Lightly Played (LP) — Leichte, sichtbare Spielspuren an Kanten oder Oberfläche.',
    MP: 'Moderately Played (MP) — Deutlichere Gebrauchsspuren, z. B. Kratzer oder leichtes Whitening.',
    DMG: 'Damaged (DMG) — Stärkere Beschädigungen wie Knicke, Risse oder größere Oberflächenschäden.',
  };

  function conditionFromVariant(variant) {
    if (!variant) return '';
    const values = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    for (const value of values) {
      const code = String(value).toUpperCase().trim();
      if (HINTS[code]) return code;
    }
    return '';
  }

  function updateHint(root, code) {
    const hint = root.querySelector('[data-tcg-condition-hint]');
    if (!hint) return;
    const text = HINTS[code] || '';
    hint.textContent = text;
    hint.hidden = !text;
  }

  const LOW_STOCK_THRESHOLD = 5;

  function stockMarkup(variant, { cartQty = 0, liveAvailable = null } = {}) {
    const shopifyQty = variant.inventory_quantity;
    const available =
      liveAvailable != null ? Math.max(0, Number(liveAvailable) || 0) : shopifyQty;
    const canAddMore = Math.max(0, available - cartQty);

    if (cartQty > 0 && canAddMore <= 0) {
      return {
        className: 'tcg-single-buy-box__stock tcg-single-buy-box__stock--ok',
        html:
          '<span class="tcg-single-buy-box__stock-dot tcg-single-buy-box__stock-dot--ok" aria-hidden="true"></span>' +
          '<span class="tcg-single-buy-box__stock-text"><strong>In deinem Warenkorb</strong> — keine weiteren Stück verfügbar</span>',
      };
    }

    if (available > 0 && available < LOW_STOCK_THRESHOLD) {
      const label = available === 1 ? 'Nur noch 1 Stück' : `Nur noch ${available} Stück`;
      return {
        className: 'tcg-single-buy-box__stock tcg-single-buy-box__stock--low',
        html:
          '<span class="tcg-single-buy-box__stock-dot tcg-single-buy-box__stock-dot--low" aria-hidden="true"></span>' +
          `<span class="tcg-single-buy-box__stock-text"><strong>${label}</strong> verfügbar</span>`,
      };
    }
    if (available > 0) {
      return {
        className: 'tcg-single-buy-box__stock tcg-single-buy-box__stock--ok',
        html:
          '<span class="tcg-single-buy-box__stock-dot tcg-single-buy-box__stock-dot--ok" aria-hidden="true"></span>' +
          `<span class="tcg-single-buy-box__stock-text"><strong>${available} Stück</strong> auf Lager — Versand aus Deutschland</span>`,
      };
    }
    if (variant.inventory_policy === 'continue') {
      return {
        className: 'tcg-single-buy-box__stock tcg-single-buy-box__stock--ok',
        html:
          '<span class="tcg-single-buy-box__stock-dot tcg-single-buy-box__stock-dot--ok" aria-hidden="true"></span>' +
          '<span class="tcg-single-buy-box__stock-text">Verfügbar (Nachbestellung)</span>',
      };
    }
    return {
      className: 'tcg-single-buy-box__stock tcg-single-buy-box__stock--out',
      html:
        '<span class="tcg-single-buy-box__stock-dot tcg-single-buy-box__stock-dot--out" aria-hidden="true"></span>' +
        '<span class="tcg-single-buy-box__stock-text">Derzeit ausverkauft</span>',
    };
  }

  function resolveLiveAvailable(variant) {
    const api = window.Kl24InventoryReservation;
    if (!api?.isEnabled?.() || !variant?.id) return null;
    const cached = api.getCachedAvailability?.({ variantId: variant.id });
    if (cached) return cached.available;
    return null;
  }

  function updateStock(sectionId, variant) {
    const stock = document.querySelector(`#TcgStock-${sectionId}`);
    if (!stock || !variant) return;
    if (variant.inventory_management !== 'shopify') return;
    const input = document.querySelector(`#Quantity-${sectionId}`);
    const cartQty = parseInt(input?.dataset.cartQuantity || '0', 10) || 0;
    const liveAvailable = resolveLiveAvailable(variant);
    const { className, html } = stockMarkup(variant, { cartQty, liveAvailable });
    stock.className = className;
    stock.innerHTML = html;
  }

  function updateQuantityCap(sectionId, variant) {
    const input = document.querySelector(`#Quantity-${sectionId}`);
    if (!input || !variant) return;

    const cartQty = parseInt(input.dataset.cartQuantity || '0', 10) || 0;

    if (variant.inventory_management !== 'shopify') {
      input.removeAttribute('data-tcg-stock-cap');
      input.removeAttribute('data-max');
      input.removeAttribute('max');
      return;
    }

    const shopifyStock = variant.inventory_quantity;
    const liveAvailable = resolveLiveAvailable(variant);
    const stock = liveAvailable != null ? liveAvailable : shopifyStock;

    if (variant.inventory_policy === 'continue' && stock <= 0 && liveAvailable == null) {
      input.removeAttribute('data-tcg-stock-cap');
      input.removeAttribute('data-max');
      input.removeAttribute('max');
      return;
    }

    if (stock > 0 || liveAvailable != null) {
      const cap = Math.max(0, stock);
      input.setAttribute('data-max', String(cap));
      input.dataset.tcgStockCap = String(cap);
      const available = Math.max(0, cap - cartQty);
      const min = parseInt(input.dataset.min || input.min || '1', 10) || 1;
      if (available > 0) {
        input.max = available;
        input.removeAttribute('disabled');
        if (parseInt(input.value, 10) > available) input.value = available;
        if (parseInt(input.value, 10) < min) input.value = Math.min(min, available);
      } else {
        input.max = 0;
        input.value = 0;
      }
    } else {
      input.setAttribute('data-max', '0');
      input.max = 0;
      input.value = 0;
    }

    const quantityInput = input.closest('quantity-input');
    if (quantityInput?.validateQtyRules) quantityInput.validateQtyRules();
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
  }

  async function refreshLiveAvailability(sectionId, variant) {
    const api = window.Kl24InventoryReservation;
    if (!api?.isEnabled?.() || !variant?.id) return;
    try {
      await api.fetchAvailability({ variantIds: [variant.id], force: true });
    } catch (error) {
      console.warn('[TCG Buy-Box] availability:', error);
    }
    updateStock(sectionId, variant);
    updateQuantityCap(sectionId, variant);
  }

  function initBuyBox(root) {
    const sectionId = root.dataset.sectionId;
    if (!sectionId || typeof subscribe !== 'function') return;

    const variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (!event?.data?.variant) return;
      const code = conditionFromVariant(event.data.variant);
      if (code) updateHint(root, code);
      void refreshLiveAvailability(sectionId, event.data.variant);
    });

    document.addEventListener(
      'shopify:section:unload',
      () => {
        if (typeof variantChangeUnsub === 'function') variantChangeUnsub();
      },
      { once: true }
    );

    document.addEventListener('kl24:availability', () => {
      const variant = getVariantForSection(sectionId);
      if (variant) {
        updateStock(sectionId, variant);
        updateQuantityCap(sectionId, variant);
      }
    });
  }

  function getVariantForSection(sectionId) {
    const productInfo =
      document.querySelector(`product-info[data-section="${sectionId}"]`) ||
      document.querySelector('product-info.tcg-product--single') ||
      document.querySelector('product-info');
    if (!productInfo) return null;
    const raw = productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent;
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function bindProductInfoQuantity(sectionId) {
    const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
    if (!productInfo || productInfo.dataset.tcgQtyBound === 'true') return;
    productInfo.dataset.tcgQtyBound = 'true';

    const runCap = () => {
      const variant = getVariantForSection(sectionId);
      if (variant) {
        updateStock(sectionId, variant);
        updateQuantityCap(sectionId, variant);
      }
    };

    productInfo.addEventListener('product-info:loaded', runCap);
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, runCap);
      subscribe(PUB_SUB_EVENTS.quantityUpdate, runCap);
    }
    runCap();
  }

  function boot() {
    document.querySelectorAll('[data-tcg-buy-box]').forEach((root) => {
      initBuyBox(root);
      const sectionId = root.dataset.sectionId;
      if (sectionId) {
        bindProductInfoQuantity(sectionId);
        const variant = getVariantForSection(sectionId);
        if (variant) void refreshLiveAvailability(sectionId, variant);
      }
      const activePill = root.querySelector('.tcg-single-buy-box__pill.is-active');
      if (activePill) {
        updateHint(root, activePill.textContent.trim().toUpperCase());
      } else {
        const hint = root.querySelector('[data-tcg-condition-hint]');
        if (hint && hint.textContent.trim()) hint.hidden = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
